module.exports = __webpack_public_path__ + "static/media/caret_down.a19124d5.svg";